export const WIRES_FX_WORKFLOW_CONTAINER_TAG_NAME = 'wires-fx-workflow-container';
